import React from "react";
import "./Serve.css";
import Accordion from "react-bootstrap/Accordion";
// import { FaPlus } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";

const Serve = ({ loanApplyType }) => {
  const accordionData =
    loanApplyType === "pl"
      ? [
          {
            title: "Personal Loan Eligibility",
            content: (
              <p className="m-0">
                A Quick Guide Your personal loan eligibility depends on several
                factors like your income, credit score, and existing financial
                obligations. Most banks look for a credit score of 660+ and a
                steady income stream. At Minemi, we help you check your
                eligibility instantly, so you know exactly where you stand
                before applying for a personal loan, without impacting your
                credit score. Know your chances upfront, and avoid unnecessary
                rejections!
              </p>
            ),
          },
          {
            title: "Features and Benefits of Personal Loan",
            content: (
              <div>
                Features and Benefits of Personal Loan & Benefits of Checking
                Eligibility Before Applying Features and Benefits of a Personal
                Loan Personal loans offer flexibility, whether you need funds
                for medical emergencies, education, or home renovations.
                <p className="my-2">Key features include:</p>
                <p className="my-1">• No collateral required</p>
                <p className="m-0">• Flexible repayment tenures</p>
                <p className="my-1">• Competitive interest rates</p>
                <p className="m0">• Quick disbursal</p>
                especially when applying online Why Check Personal Loan
                Eligibility Before Applying? Checking your loan eligibility
                before applying for a personal loan is crucial to avoid multiple
                hard credit inquiries, which can lower your credit score. With
                Minemi, you can pre-check your eligibility without affecting
                your score, allowing you to select the right bank or financial
                institution. This saves you time, minimizes rejection chances,
                and provides a personalized loan recommendation.
              </div>
            ),
          },
          {
            title: "When Should You Consider a Personal Loan?",
            content: (
              <p className="m-0">
                When to Consider a Personal Loan A personal loan can be the
                right choice when you need quick access to funds for situations
                like debt consolidation, unexpected medical expenses, weddings,
                or even home repairs. The flexibility of use, easy approvals,
                and manageable EMIs make personal loans convenient for
                short-term financial needs. However, it's important to assess
                your repayment ability before taking on a new loan. Use Minemi's
                eligibility checker to explore the best loan options for your
                needs.
              </p>
            ),
          },
          {
            title: "Required Documents",
            content: (
              <div>
                Required Documents Documents You Need for a Personal Loan Here's
                a checklist of documents you'll need to apply for a personal
                loan
                <p className="my-1">
                  • Identity Proof: PAN Card, Aadhaar Card, Passport
                </p>
                <p className="m-0">
                  • Address Proof: Utility bills, Aadhaar, or rental agreements
                </p>
                <p className="my-1">
                  • Income Proof: Latest salary slips or bank statements (for
                  salaried), IT returns or audited financials (for
                  self-employed)
                </p>
                <p className="m-0">
                  • Employment Proof: Offer letter or work ID Having these
                  documents ready will speed up the personal loan application
                  process, so be prepared before applying.
                </p>
              </div>
            ),
          },
          {
            title: " Frequently Asked Questions (FAQs) ",
            content: (
              <div className="m-0">
                <p className="m-0">
                  1. What is the minimum credit score required for a personal
                  loan? Most lenders prefer a credit score above 660, but
                  eligibility can vary by lender. Check your personal loan
                  eligibility with Minemi to find out where you stand.
                </p>
                <p className="my-2">
                  2. How much personal loan can I get? Your personal loan amount
                  depends on your income, current financial obligations, and
                  credit score. Use Minemi's eligibility checker to see how much
                  you qualify for without affecting your credit score.
                </p>
                <p className="m-0">
                  3. Does checking loan eligibility impact my credit score? No,
                  checking your eligibility through Minemi does not impact your
                  credit score since it's a soft inquiry.
                </p>
                <p className="my-2">
                  4. Can I apply for a personal loan if I have other ongoing
                  loans? Yes, but your eligibility is influenced by your FOIR
                  (Fixed Obligation to Income Ratio). Minemi can help you
                  understand how your existing loans affect your personal loan
                  eligibility.
                </p>
                <p className="m-0">
                  5. How quickly can I get my personal loan? Personal loans are
                  typically disbursed within a few days, depending on the
                  lender’s verification process. Use Minemi to streamline the
                  process and get personalized loan offers.
                </p>
              </div>
            ),
          },
        ]
      : loanApplyType === "cl"
      ? [
          {
            title: "Car Loan Eligibility",
            content: (
              <p className="m-0">
                A Quick Guide Car loan eligibility depends on your income,
                credit score, and the type of car you wish to purchase. Most
                lenders look for a credit score of 650+ and a steady income. At
                Minemi, you can check your car loan eligibility instantly,
                without impacting your credit score. This way, you know where
                you stand before applying, ensuring a smoother loan process and
                avoiding rejections.
              </p>
            ),
          },
          {
            title: "Benefits of Car Loan",
            content: (
              <div>
                Car loans are designed to help you purchase your dream car with
                ease.
                <p className="my-2">Key features include:</p>
                <p className="my-1">• Attractive interest rates</p>
                <p className="m-0">
                  • Flexible repayment tenures (up to 7 years)
                </p>
                <p className="my-1">
                  • No need for collateral apart from the car itself
                </p>
                <p className="m0">• Quick approval and disbursal process</p>
              </div>
            ),
          },
          {
            title: "Why Check Car Loan Eligibility Before Applying?",
            content: (
              <p className="m-0">
                Checking your car loan eligibility before applying helps you
                avoid multiple hard inquiries on your credit report, which can
                lower your score. Minemi allows you to check your eligibility
                without any impact on your credit score. This lets you find the
                right lender and loan terms, ensuring a smooth and quick
                approval process.
              </p>
            ),
          },
          {
            title: "When Should You Consider a Car Loan?",
            content: (
              <div>
                A car loan is perfect when you're planning to buy a new or used
                vehicle but prefer not to make an outright payment. Car loans
                offer flexible repayment options, low interest rates, and a
                simple application process. Before you apply, ensure that the
                EMI fits within your monthly budget. Use Minemi's eligibility
                checker to determine the best loan options without affecting
                your credit score.
              </div>
            ),
          },
          {
            title: " Documents You Need for a Car Loan ",
            content: (
              <div>
                To apply for a car loan, you'll typically need the following
                documents:
                <p className="my-1">
                  • Identity Proof: PAN Card, Aadhaar Card, Passport
                </p>
                <p className="my-1">
                  • Address Proof: Utility bills, Aadhaar, or rental agreements
                </p>
                <p className="m-0">
                  • Income Proof: Salary slips or bank statements (for
                  salaried), IT returns or audited financials (for
                  self-employed)
                </p>
                <p className="my-1">
                  • Employment Proof: Offer letter or employment certificate.
                </p>
                <p className="m0">
                  • Vehicle Details: Proforma invoice of the car you wish to buy
                  Having these documents ready will help you speed up the car
                  loan application process.
                </p>
              </div>
            ),
          },
          {
            title: " Frequently Asked Questions (FAQs) ",
            content: (
              <div className="m-0">
                <p className="m-0">
                  1. What is the minimum credit score required for a car loan?
                  Most lenders require a credit score of 650 or higher. Check
                  your car loan eligibility with Minemi to see your options
                  without affecting your score.
                </p>
                <p className="my-2">
                  2. How much car loan can I get? The loan amount is determined
                  by your income, credit score, and the price of the car. Use
                  Minemi's eligibility checker to get an estimate.
                </p>
                <p className="m-0">
                  3. Will checking car loan eligibility impact my credit score?
                  No, checking your eligibility through Minemi uses a soft
                  inquiry that doesn't impact your credit score.
                </p>
                <p className="my-2">
                  4. Can I get a car loan for a used vehicle? Yes, many lenders
                  offer car loans for used vehicles as well. Minemi can help you
                  find the best lenders for your needs.
                </p>
                <p className="m-0">
                  5. How quickly can I get a car loan? Car loans are typically
                  approved quickly, often within a day or two. Minemi helps
                  speed up the process by providing personalized loan offers.
                </p>
              </div>
            ),
          },
        ]
      : [
          {
            title: "Home Loan Eligibility",
            content: (
              <p className="m-0">
                A Quick Guide Your home loan eligibility depends on various
                factors such as your income, credit score, the value of the
                property, and your current financial obligations. Typically, a
                credit score of 700+ is preferred by most banks, along with a
                stable income history. At Minemi, we provide a quick and easy
                way to check your home loan eligibility instantly, without
                affecting your credit score. Know your eligibility upfront and
                get personalized loan options that fit your needs, avoiding
                unnecessary rejections!
              </p>
            ),
          },
          {
            title: "Features and Benefits of Home Loan",
            content: (
              <div>
                Home loans are essential when purchasing your dream home, and
                they offer several.
                <p className="my-2">key benefits include:</p>
                <p className="my-1">
                  • Low interest rates compared to other loans
                </p>
                <p className="m-0">
                  • Longer repayment tenures (up to 30 years)
                </p>
                <p className="my-1">
                  • No need for collateral apart from the car itself
                </p>
                <p className="m0">
                  • Tax benefits on both principal and interest repayments
                </p>
                <p className="m0">
                  • Flexibility to choose fixed or floating interest rates
                </p>
              </div>
            ),
          },
          {
            title: "Why Check Home Loan Eligibility Before Applying?",
            content: (
              <p className="m-0">
                Checking your home loan eligibility before applying ensures that
                you understand your borrowing capacity and avoid multiple hard
                credit inquiries that could harm your credit score. With Minemi,
                you can check your home loan eligibility without affecting your
                score, allowing you to explore various options from different
                lenders. This saves you time, minimizes rejection chances, and
                provides a clearer view of the best financial institution for
                your loan.
              </p>
            ),
          },
          {
            title: "When Should You Consider a Home Loan?",
            content: (
              <div>
                A home loan is ideal when you're ready to purchase or construct
                your dream home, or even refinance an existing property. You can
                also use a home loan for buying a plot of land or for home
                improvements. With longer tenures and lower interest rates, home
                loans are structured to offer affordability over time. However,
                it's essential to evaluate your repayment capacity before taking
                a loan. Use Minemi's home loan eligibility checker to determine
                the best options available to you.
              </div>
            ),
          },
          {
            title:
              "Documents You Need for a Home Loan When applying for a home loan",
            content: (
              <div>
                You will need to submit the following documents:
                <p className="my-1">
                  • Identity Proof: PAN Card, Aadhaar Card, Passport
                </p>
                <p className="my-1">
                  • Address Proof: Utility bills, Aadhaar, or rental agreements
                </p>
                <p className="m-0">
                  • Income Proof: Salary slips or bank statements for salaried,
                  IT returns or audited financials for self-employed
                </p>
                <p className="my-1">
                  • Property Documents: Agreement to Sale, Title Deed, Approved
                  Building Plan
                </p>
                <p className="m0">
                  • Employment Proof: Offer letter, Form 16, or employment
                  certificate Having these documents ready will speed up the
                  home loan approval process.
                </p>
              </div>
            ),
          },
          {
            title: "Frequently Asked Questions (FAQs)",
            content: (
              <div className="m-0">
                <p className="m-0">
                  1. What is the minimum credit score required for a home loan?
                  Most lenders prefer a credit score of 700+ for home loan
                  approvals, but the actual requirement may vary. Use Minemi's
                  eligibility checker to know where you stand.
                </p>
                <p className="my-2">
                  2. How much home loan can I get? The loan amount depends on
                  your income, credit score, and the value of the property. Use
                  Minem's eligibility checker to find out how much you can
                  borrow without affecting your credit score.
                </p>
                <p className="m-0">
                  3. Will checking home loan eligibility impact my credit score?
                  No, Minemi uses a soft inquiry method to check your
                  eligibility, so it doesn't impact your credit score.
                </p>
                <p className="my-2">
                  4. Can I get a home loan for property under construction? Yes,
                  many lenders offer home loans for properties under
                  construction. Minemi can help you find lenders that suit your
                  needs.
                </p>
                <p className="m-0">
                  5. How long does it take to get a home loan? Home loans
                  typically take a few weeks to process, depending on property
                  verification and documentation. Minemi streamlines the process
                  and provides faster access to offers.
                </p>
              </div>
            ),
          },
        ];
  return (
    <>
      <div id="serve">
        <div className="contentCon">
          <div id="header-con">
            <p className="bg-transparent">We swear to serve you with ...</p>
          </div>
          <div id="content" className="bg-transparent">
            <div className="d-flex flex-wrap w-100 bg-transparent">
              <div className="loan-info-con bg-transparent ">
                <img
                  className="bg-transparent"
                  src="/Assets/Images/loan_eligibility.webp"
                  alt="your-loan"
                />
                <p className="bg-transparent">Your Loan Eligibility</p>
              </div>

              <div className="plus-icon-con bg-transparent">
                <FaPlus className="plus-icon bg-transparent" />
              </div>
              <div className="loan-info-con bg-transparent ">
                <img
                  className="bg-transparent"
                  src="/Assets/Images/no_empact.webp"
                  alt="your-loan"
                />
                <p className="bg-transparent">No Impact on credit Score</p>
              </div>

              <div className="plus-icon-con second-icon bg-transparent">
                <FaPlus className="plus-icon bg-transparent" />
              </div>
              <div className="loan-info-con bg-transparent ">
                <img
                  className="bg-transparent"
                  src="/Assets/Images/interest_rate.webp"
                  alt="your-loan"
                />
                <p className="bg-transparent">Best Interest Rate Offer</p>
              </div>

              <div className="plus-icon-con bg-transparent">
                <FaPlus className="plus-icon bg-transparent" />
              </div>
              <div className="loan-info-con bg-transparent">
                <img
                  className="bg-transparent"
                  src="/Assets/Images/no_calls.webp"
                  alt="your-loan"
                />
                <p className="bg-transparent">No Calls From Us</p>
              </div>

              <div className="plus-icon-con fourth-icon bg-transparent">
                <FaPlus className="plus-icon bg-transparent" />
              </div>
              <div className="loan-info-con bg-transparent ">
                <img
                  className="bg-transparent"
                  src="/Assets/Images/data_securities.webp"
                  alt="your-loan"
                />
                <p className="bg-transparent">Data Security Guarantee</p>
              </div>

              <div className="plus-icon-con bg-transparent">
                <FaPlus className="plus-icon bg-transparent" />
              </div>
              <div className="loan-info-con bg-transparent">
                <img
                  className="bg-transparent"
                  src="/Assets/Images/data_securities.webp"
                  alt="your-loan"
                />
                <p className="bg-transparent">Your Loan Eligibility</p>
              </div>
            </div>

            <div id="line-breaker"></div>

            <div className="accordion-con bg-transparent">
              <Accordion className="bg-transparent">
                {accordionData.map((item, index) => (
                  <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>{item.title}</Accordion.Header>
                    <Accordion.Body
                      style={{
                        visibility: "visible",
                        backgroundColor: "transparent",
                      }}
                    >
                      {item.content}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Serve;
